
import { Observable, throwError as observableThrowError } from 'rxjs'

import { catchError } from 'rxjs/operators'



import { getState } from 'store/state'
import { ApiException, NotAuthorizedException } from './exceptions'

type O<T> = Observable<T>

/**
 * Enables reauthorization on the requests in request$
 *
 * It's important that the request$' items will re-sign if they were retried. This means that any branching cush as flatmap and others
 * have to happen either after this call or before the signing.
 *
 * @export
 * @template T
 * @param {Observable<T>} request$
 * @param {StoreDispatch} dispatch
 * @param {getState} getState
 * @param {() => Observable<T>} onRetry
 * @returns
 */
export function authorizedAjax<T>(request$: O<T>, _getState: getState, onRetry: () => O<T>, silent = false) {
  return request$.pipe(
    catchError((incoming: any) => {
      let error: Error | ApiException = incoming
      if (!(error instanceof Error)) {
        const description = typeof incoming === 'object' ? JSON.stringify(incoming, (_k, v) => {
          if (typeof v === 'function') return `[Function ${v.name || 'anonymous'}]`
          return v
        }, 2) : String(incoming)
        const wrapped = new Error('[authorizedAjax] Non-Error rejection: ' + description)
        ;(wrapped as any).original = incoming
        error = wrapped
      }

      if (error instanceof NotAuthorizedException) {
        if (!silent) {
          console.log('[authorizedAjax] changing signer', (error as any).request)
        }
        return onRetry()
      }
      return observableThrowError(() => error)
    }))
}

export default authorizedAjax
